import { Injectable } from '@angular/core';
import fetch from 'node-fetch';

import { environment } from '../../../../environments/environment';
import { Toggle } from '../../modules';

@Injectable({
  providedIn: 'root',
})

/* eslint-disable @typescript-eslint/no-explicit-any */
export class GatekeeperService {
  readonly featureToggleList = [
    'service_interruption',
    'rcc_coach_mark',
    'rcc_introduction_modal',
    'REDESIGN_FEEDBACK_SURVEY',
    'STATE_TAX_RATES'
  ].join(',');

  gatekeeperUrl = environment.gatekeeperUrl;
  gatekeeperRegion = environment.gatekeeperRegion;
  private static toggleList: Toggle[] = [];
  constructor() {}

  /**
   * This function takes a list of feature toggles and writes their values to a static array
   *
   * @param featureIdList This is the featureIdList to check.
   */
  public async setFeatureToggleList(featureIdList: string = this.featureToggleList) {
    let responseData;
    try {
      const response = await fetch(
        this.gatekeeperUrl +
          '?' +
          new URLSearchParams({
            featureIds: featureIdList,
            env: this.gatekeeperRegion,
          }),
      );
      if (response.ok && response.status == 200) {
        responseData = await response.json();
        responseData.forEach((toggle) => {
          const transformedToggle = new Toggle();
          transformedToggle.id = toggle['featureId'];
          transformedToggle.status = toggle['enabled'];
          GatekeeperService.toggleList.push(transformedToggle);
        });
      } else {
        console.log(
          'No user data or Bad response from Gatekeeper REST service. (Error: ' +
            response.status +
            ')',
        );
      }
    } catch (error) {
      console.log('Unable to reach the Gatekeeper REST service. (error: ' + error + ')');
    }
  }

  public getToggleValue(toggleName: string) {
    try {
      const toggleStatus = GatekeeperService.toggleList.find(
        (toggle) => toggle.id === toggleName,
      )?.status;
      // console.log("toggleStatus: " + toggleStatus)
      if (toggleName === undefined || toggleStatus === undefined) {
        return false;
      } else {
        return toggleStatus;
      }
    } catch {
      return false;
    }
  }
}
